var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serviceStatus)?_c('b-link',{staticClass:"appstatusindicator",attrs:{"target":"_blank","href":"https://status.wbs.ac.uk","rel":"Warwick Business School service status page"}},[_c('div',{staticClass:"status-indicator",style:(_vm.indicatorBgColor),attrs:{"title":_vm.serviceStatus}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }